const CHANNEL_NAME = 'getplan-notification-claims';
const HIDDEN_TAB_DELAY_MS = 250;
const MAX_JITTER_MS = 60;
const MAX_REMEMBERED = 200;

const claimed = new Set();
let channel = null;

const remember = (id) => {
  claimed.add(id);
  if (claimed.size > MAX_REMEMBERED) claimed.delete(claimed.values().next().value);
};

if (typeof BroadcastChannel !== 'undefined') {
  channel = new BroadcastChannel(CHANNEL_NAME);
  channel.onmessage = (event) => {
    if (event.data && event.data.id) remember(event.data.id);
  };
}

export const claimNotification = async (id) => {
  if (!channel || !id) return true;

  const baseDelay = document.visibilityState === 'visible' ? 0 : HIDDEN_TAB_DELAY_MS;
  await new Promise((resolve) => setTimeout(resolve, baseDelay + Math.random() * MAX_JITTER_MS));

  if (claimed.has(id)) return false;
  remember(id);
  channel.postMessage({ id });
  return true;
};
